import React, { useEffect, useState } from "react";
import {
  makeStyles,
  Divider,
  Container,
  Box,
  Card,
  CardContent,
  CardHeader,
  Button,
  Fade,
  Modal,
  FormControl,
  InputLabel,
  MenuItem,
  FormHelperText,
} from "@material-ui/core";

import MaterialTable from "material-table";
import { useSelector, useDispatch } from "react-redux";
import { AlertTitle, Alert } from "@material-ui/lab";
import _ from "lodash";
import Page from "src/components/Page";
import { Backdrop } from "@material-ui/core";
import { Field, Form, Formik } from "formik";
import {
  createConditionContract,
  fetchBudgetList,
  fetchConditionContract,
} from "src/redux/actions/contract.action";
import CustomSelectInput from "src/components/inputs/CustomSelectInput";
import { TextField } from "formik-material-ui";
import * as yup from "yup";
import NoteAddIcon from "@material-ui/icons/NoteAdd";

const useStyles = makeStyles((theme) => ({
  root: {
    flex: 1,
    "& .MuiTextField-root": {
      margin: theme.spacing(1),
      width: "26ch",
    },
    "& .MuiButton-root": {
      margin: theme.spacing(1),
    },
    "& .MuiFormControl-root": {
      margin: theme.spacing(2),
    },
    backgroundColor: theme.palette.background.dark,
    minHeight: "100%",
    overflow: "hidden",
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3),
  },
  inputForm: {
    margin: theme.spacing(1, 1, 1),
    width: "25ch",
  },
  buttonForm: {
    margin: theme.spacing(0, 1, 0),
  },
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    border: "2px solid #000",
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    minWidth: 500,
  },
}));

const ConditionContractSearchPage = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [openModalForm, setOpenModalForm] = useState(false);

  const [dataForm, setDataForm] = useState({
    PRCCID: 0,
    BGIDX: null,
    AMOUNT_LIMITE: null,
    PRC_ACTIVE: 1,
  });

  const { purchaseRequests } = useSelector(
    (state) => state.purchaseRequestReducer
  );

  const { conditionContracts, budgetList } = useSelector(
    (state) => state.contractReducer
  );

  useEffect(() => {
    dispatch(fetchConditionContract());
    dispatch(fetchBudgetList());
  }, []);

  if (
    (conditionContracts && conditionContracts.isRejected) ||
    (budgetList && budgetList.isRejected)
  ) {
    return (
      <div className={classes.root}>
        <Alert severity="error">
          <AlertTitle>Error</AlertTitle>
          This is an error alert —{" "}
          <strong>Get Purchase Requisition data!</strong>
        </Alert>
      </div>
    );
  }

  const duplicateNameCheck = (list, value) => {
    let checkResult = _.find(list, "BGIDX", value);
    if (checkResult) {
      return false;
    }
    return true;
  };

  const formContract = yup.object().shape({
    AMOUNT_LIMITE: yup
      .number()
      .positive("Amount must be a positive number")
      .typeError("Amount can not be blank"),
    BGIDX: yup
      .string()
      .typeError("Budget Code can not be blank")
      .test("Unique", "Data is duplicated", (values) => {
        return duplicateNameCheck(conditionContracts.data, values);
      }),
  });

  return (
    <Page className={classes.root} title="Condition Contract Search">
      <Container maxWidth={false}>
        <Card>
          <CardHeader subheader="" title="Condition Contract Search" />
          <Divider />
          <CardContent>
            <Box display="flex" flexDirection="column">
              <Box flexGrow={1}>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => {
                    setDataForm({
                      PRCCID: 0,
                      BGIDX: null,
                      AMOUNT_LIMITE: null,
                      PRC_ACTIVE: 1,
                    });
                    setOpenModalForm(true);
                  }}
                >
                  <NoteAddIcon />
                  Create Condition Contract
                </Button>
                <MaterialTable
                  title
                  isLoading={purchaseRequests.isLoading}
                  columns={[
                    {
                      title: "Budget No",
                      field: "BUDGET_CODE",
                    },
                    {
                      title: "Amount",
                      field: "AMOUNT_LIMITE",
                    },
                    {
                      title: "Status",
                      field: "PRC_ACTIVE",
                      lookup: {
                        1: "Active",
                        0: "Inactive",
                      },
                    },
                  ]}
                  data={conditionContracts && conditionContracts.data}
                  actions={[
                    (rowData) => ({
                      icon: "edit",
                      onClick: (event, rowData) => {
                        event.preventDefault();
                        setDataForm({
                          PRCCID: rowData.PRCCID,
                          BGIDX: rowData.BGIDX,
                          AMOUNT_LIMITE: rowData.AMOUNT_LIMITE,
                          PRC_ACTIVE: rowData.PRC_ACTIVE,
                        });
                        setOpenModalForm(true);
                      },
                    }),
                  ]}
                  options={{
                    filtering: true,
                    search: true,
                    showFirstLastPageButtons: false,
                  }}
                  style={{
                    width: "100%",
                  }}
                />
              </Box>
            </Box>
          </CardContent>
        </Card>
      </Container>
      <Modal
        aria-labelledby="spring-modal-title"
        aria-describedby="spring-modal-description"
        className={classes.modal}
        open={openModalForm}
        onClose={() => {
          setOpenModalForm(false);
        }}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={openModalForm}>
          <div className={classes.paper}>
            <h2 id="simple-modal-title">Maintain Condition Contract</h2>
            <Formik
              key={`contractForm`}
              enableReinitialize
              initialValues={dataForm}
              validationSchema={formContract}
              onSubmit={(values, { setSubmitting }) => {
                const { ACC_CODE } = _.find(budgetList.data, {
                  ACC_ID: values.BGIDX,
                });
                createConditionContract({ ...values, BUDGET_CODE: ACC_CODE })
                  .then(() => {
                    dispatch(fetchConditionContract());
                    dispatch(fetchBudgetList());
                  })
                  .catch(() => {});

                setOpenModalForm(false);

                setSubmitting(false);
              }}
            >
              {(formikProps) => {
                const { handleSubmit, errors } = formikProps;
                return (
                  <Form>
                    <FormControl fullWidth error={Boolean(errors.BGIDX)}>
                      <InputLabel htmlFor="BGIDX">Budget Code</InputLabel>
                      <Field
                        component={CustomSelectInput}
                        name="BGIDX"
                        label="Budget Code"
                        labelId="BGIDX"
                        onChange={() => {}}
                      >
                        {budgetList &&
                          budgetList.data.map((i) => (
                            <MenuItem value={i.ACC_ID}>{i.ACC_CODE}</MenuItem>
                          ))}
                      </Field>
                      {errors.BGIDX && (
                        <FormHelperText>{errors.BGIDX}</FormHelperText>
                      )}
                    </FormControl>
                    <FormControl fullWidth>
                      <Field
                        component={TextField}
                        name="AMOUNT_LIMITE"
                        label="Amount"
                        error={Boolean(errors.AMOUNT_LIMITE)}
                        helperText=""
                      />
                    </FormControl>
                    <FormControl fullWidth>
                      <InputLabel htmlFor="PRC_ACTIVE">Status</InputLabel>
                      <Field
                        component={CustomSelectInput}
                        name="PRC_ACTIVE"
                        label="Status"
                        labelId="PRC_ACTIVE"
                        onChange={() => {}}
                        fullWidth
                      >
                        <MenuItem value={1}>Active</MenuItem>
                        <MenuItem value={0}>Unactive</MenuItem>
                      </Field>
                    </FormControl>
                    <Divider />
                    <Box pt={5} display="flex" justifyContent="space-around">
                      <Button variant="contained" onClick={handleSubmit}>
                        Save
                      </Button>
                      <Button
                        variant="contained"
                        onClick={() => {
                          setOpenModalForm(false);
                        }}
                      >
                        Close
                      </Button>
                    </Box>
                  </Form>
                );
              }}
            </Formik>
          </div>
        </Fade>
      </Modal>
    </Page>
  );
};

export default ConditionContractSearchPage;
